import { render } from "./TapPoints.vue?vue&type=template&id=f51d7b98&scoped=true"
import script from "./TapPoints.vue?vue&type=script&lang=js"
export * from "./TapPoints.vue?vue&type=script&lang=js"

import "./TapPoints.vue?vue&type=style&index=0&id=f51d7b98&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f51d7b98"]])

export default __exports__